import { DEFAULT_IMAGE_FORM_PARAMS, DEFAULT_STORY_GRID_SETTINGS, MODEL_VERSION } from '@/app/constants';
import { BackfillTaskType, type TaskInfo, type ViduV1Element } from '@/app/types';

export type ReferenceBackfillTarget =
  | BackfillTaskType.CHARACTER2VIDEO
  | BackfillTaskType.REFERENCE2IMAGE
  | BackfillTaskType.STORY_GRID;

export const isReferenceBackfillTarget = (target: BackfillTaskType): target is ReferenceBackfillTarget =>
  target === BackfillTaskType.CHARACTER2VIDEO ||
  target === BackfillTaskType.REFERENCE2IMAGE ||
  target === BackfillTaskType.STORY_GRID;

export const getReferenceBackfillSettings = (
  target: ReferenceBackfillTarget,
  modality?: ViduV1Element['modality'],
): TaskInfo['settings'] => {
  if (target === BackfillTaskType.STORY_GRID) {
    return { ...DEFAULT_STORY_GRID_SETTINGS };
  }

  if (target === BackfillTaskType.REFERENCE2IMAGE) {
    return {
      ...DEFAULT_IMAGE_FORM_PARAMS.settingsGPTImage2,
      model_version: DEFAULT_IMAGE_FORM_PARAMS.modelVersion,
    };
  }

  return {
    model_version: modality === 'video' ? MODEL_VERSION.Q2_PRO : MODEL_VERSION.Q2,
    duration: 5,
    resolution: '1080p',
  };
};
